(function () {

  // --------------------------
  // TABLE SIZE DATA (METRES)
  // --------------------------
  const TABLE_DATA = [
    // English
    { style: 'English', size: '6 ft', cue: 36, roomLengthM: 3.50, roomWidthM: 2.73 },
    { style: 'English', size: '6 ft', cue: 48, roomLengthM: 4.10, roomWidthM: 3.33 },
    { style: 'English', size: '6 ft', cue: 57, roomLengthM: 4.56, roomWidthM: 3.79 },

    { style: 'English', size: '7 ft', cue: 36, roomLengthM: 3.73, roomWidthM: 2.82 },
    { style: 'English', size: '7 ft', cue: 48, roomLengthM: 4.33, roomWidthM: 3.38 },
    { style: 'English', size: '7 ft', cue: 57, roomLengthM: 4.79, roomWidthM: 3.88 },

    { style: 'English', size: '8 ft', cue: 36, roomLengthM: 4.01, roomWidthM: 2.96 },
    { style: 'English', size: '8 ft', cue: 48, roomLengthM: 4.61, roomWidthM: 3.56 },
    { style: 'English', size: '8 ft', cue: 57, roomLengthM: 5.07, roomWidthM: 4.02 },

    // American
    { style: 'American', size: '6 ft', cue: 36, roomLengthM: 3.69, roomWidthM: 2.79 },
    { style: 'American', size: '6 ft', cue: 48, roomLengthM: 4.29, roomWidthM: 3.39 },
    { style: 'American', size: '6 ft', cue: 57, roomLengthM: 4.75, roomWidthM: 3.85 },

    { style: 'American', size: '7 ft', cue: 36, roomLengthM: 3.88, roomWidthM: 2.89 },
    { style: 'American', size: '7 ft', cue: 48, roomLengthM: 4.48, roomWidthM: 3.49 },
    { style: 'American', size: '7 ft', cue: 57, roomLengthM: 4.94, roomWidthM: 3.95 },

    { style: 'American', size: '8 ft', cue: 36, roomLengthM: 4.24, roomWidthM: 3.07 },
    { style: 'American', size: '8 ft', cue: 48, roomLengthM: 4.84, roomWidthM: 3.67 },
    { style: 'American', size: '8 ft', cue: 57, roomLengthM: 5.30, roomWidthM: 4.13 },

    { style: 'American', size: '9 ft', cue: 36, roomLengthM: 4.44, roomWidthM: 3.17 },
    { style: 'American', size: '9 ft', cue: 48, roomLengthM: 5.04, roomWidthM: 3.77 },
    { style: 'American', size: '9 ft', cue: 57, roomLengthM: 5.50, roomWidthM: 4.23 }
  ];

  // Collection links for size-based results
  const SIZE_COLLECTIONS = {
    '6 ft': '/en-gb/collections/6ft-pool-tables',
    '7 ft': '/en-gb/collections/7ft-pool-tables',
    '8 ft': '/en-gb/collections/8ft-pool-tables',
    '9 ft': '/en-gb/collections/9ft-pool-tables'
  };

  const M_PER_FT = 0.3048;

  // --------------------------
  // DOM ELEMENTS
  // --------------------------
  const form = document.getElementById('prc-form');
  if (!form) return; // Stop if the calculator isn't on this page

  const unitInput = document.getElementById('prc-unit');
  const unitButtons = form.querySelectorAll('.prc-unit-btn');
  const lengthInput = document.getElementById('prc-length');
  const widthInput = document.getElementById('prc-width');
  const cueInputs = form.querySelectorAll('input[name="prc-cue"]');
  const resultsContainer = document.getElementById('prc-results-container');
  const roomSummary = document.getElementById('prc-room-summary');
  const noFitBlock = document.getElementById('prc-no-fit');
  const errorEl = document.getElementById('prc-error');
  const shopLinks = document.getElementById('prc-shop-links');

  // --------------------------
  // UNIT TOGGLE
  // --------------------------
  unitButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      unitButtons.forEach(b => b.classList.remove('prc-unit-btn--active'));
      btn.classList.add('prc-unit-btn--active');
      unitInput.value = btn.getAttribute('data-unit');
    });
  });

  // --------------------------
  // HELPERS
  // --------------------------
  function getSelectedCue() {
    for (let i = 0; i < cueInputs.length; i++) {
      if (cueInputs[i].checked) return parseInt(cueInputs[i].value, 10);
    }
    return 57; // fallback
  }

  function formatDimension(value, unit) {
    if (!isFinite(value)) return '';
    return (Math.round(value * 10) / 10) + (unit === 'm' ? 'm' : 'ft');
  }

  function clearResults() {
    resultsContainer.innerHTML = '';
    roomSummary.textContent = '';
    noFitBlock.hidden = true;
    errorEl.textContent = '';
  }
function getEnglishDiagramSVG() {
  return `
    <div class="prc-diagram-wrapper">
      <svg class="prc-diagram" viewBox="0 0 420 260">

        <!-- ROOM OUTLINE -->
        <rect x="10" y="10" width="400" height="240" 
              fill="#ffffff"
              stroke="#B0C4DE"
              stroke-width="3"
              rx="6"/>

        <!-- CUE CLEARANCE ZONE -->
        <rect x="50" y="35" width="320" height="190"
              fill="#6495ED20"
              stroke="#6495ED"
              stroke-width="2"
              stroke-dasharray="6 4"
              rx="6"/>

        <!-- TABLE SURFACE (GREEN FOR ENGLISH) -->
        <rect x="130" y="80" width="160" height="100"
              fill="#1f6b3c"
              stroke="#4169E1"
              stroke-width="5"
              rx="6"/>

        <!-- LABELS -->
        <text x="210" y="28" font-size="15" text-anchor="middle" fill="#191970" font-weight="600">
          Overall Room Area
        </text>

        <text x="210" y="60" font-size="12" text-anchor="middle" fill="#4169E1">
          Cue Clearance Zone
        </text>

        <text x="210" y="135" font-size="15" text-anchor="middle" fill="#ffffff" font-weight="bold">
          English Pool Table
        </text>

      </svg>
    </div>
  `;
}

function getAmericanDiagramSVG() {
  return `
    <div class="prc-diagram-wrapper">
      <svg class="prc-diagram" viewBox="0 0 420 260">

        <!-- ROOM OUTLINE -->
        <rect x="10" y="10" width="400" height="240" 
              fill="#ffffff"
              stroke="#B0C4DE"
              stroke-width="3"
              rx="6"/>

        <!-- CUE CLEARANCE ZONE -->
        <rect x="50" y="35" width="320" height="190"
              fill="#6495ED20"
              stroke="#6495ED"
              stroke-width="2"
              stroke-dasharray="6 4"
              rx="6"/>

        <!-- TABLE SURFACE (BLUE FOR AMERICAN) -->
        <rect x="130" y="80" width="160" height="100"
              fill="#1E90FF"
              stroke="#4169E1"
              stroke-width="5"
              rx="6"/>

        <!-- LABELS -->
        <text x="210" y="28" font-size="15" text-anchor="middle" fill="#191970" font-weight="600">
          Overall Room Area
        </text>

        <text x="210" y="60" font-size="12" text-anchor="middle" fill="#4169E1">
          Cue Clearance Zone
        </text>

        <text x="210" y="135" font-size="15" text-anchor="middle" fill="#ffffff" font-weight="bold">
          American Pool Table
        </text>

      </svg>
    </div>
  `;
}

  // --------------------------
  // RENDER RESULTS
  // --------------------------
  function renderResults(fits, room, cueInches) {
    clearResults();

    roomSummary.textContent =
      'Room: ' +
      formatDimension(room.length, room.unit) + ' × ' +
      formatDimension(room.width, room.unit) +
      ' using approx. ' + cueInches + '″ cues.';

    if (!fits.length) {
      noFitBlock.hidden = false;
      resultsContainer.innerHTML =
        '<p class="prc-placeholder">Try a shorter cue length or contact us and we can check borderline cases for you.</p>';

      if (shopLinks) shopLinks.innerHTML = '';
      return;
    }

    // Group results by style
    const grouped = {};
    fits.forEach(r => {
      if (!grouped[r.style]) grouped[r.style] = [];
      grouped[r.style].push(r);
    });

    // Render English first, then American
    ['English', 'American'].forEach(styleKey => {
      const group = grouped[styleKey];
      if (!group || !group.length) return;

      const section = document.createElement('div');
      section.className = 'prc-results-style-section';

      const heading = document.createElement('h3');
      heading.textContent =
        styleKey === 'English' ? 'English pool tables' : 'American pool tables';
      section.appendChild(heading);

      group.forEach(r => {
        const recommendedLength = room.unit === 'm'
          ? r.roomLengthM
          : r.roomLengthM / M_PER_FT;

        const recommendedWidth = room.unit === 'm'
          ? r.roomWidthM
          : r.roomWidthM / M_PER_FT;

        const extra = room.unit === 'm'
          ? r.extraClearanceM
          : r.extraClearanceM / M_PER_FT;

        const extraRounded = Math.round(extra * 10) / 10;

        const badgeText =
          r.comfort === 'comfortable' ? 'Comfortable fit' : 'Tight but playable';

        const badgeClass =
          r.comfort === 'comfortable'
            ? 'prc-card-badge'
            : 'prc-card-badge prc-card-badge--tight';

        const card = document.createElement('article');
        card.className = 'prc-card';

        card.innerHTML =
          '<div class="prc-card-header">' +
            '<div class="prc-card-title">' + r.size + ' ' + styleKey + ' Pool Table</div>' +
            '<div class="' + badgeClass + '">' + badgeText + '</div>' +
          '</div>' +
          '<div class="prc-card-meta">' +
            'Recommended room: ' +
            formatDimension(recommendedLength, room.unit) + ' × ' +
            formatDimension(recommendedWidth, room.unit) +
            ' (' + (room.unit === 'm' ? 'metres' : 'feet') + ')' +
          '</div>' +
          '<ul class="prc-card-list">' +
            '<li>Table size: ' + r.size + '</li>' +
            '<li>Cue length: ' + r.cue + '″</li>' +
            '<li>Extra clearance: ~' +
              extraRounded +
              (room.unit === 'm' ? 'm' : 'ft') +
              '</li>' +
          '</ul>';

        section.appendChild(card);
      });

      resultsContainer.appendChild(section);
      // Insert diagram dynamically for each style
if (styleKey === 'English') {
  section.insertAdjacentHTML('afterbegin', getEnglishDiagramSVG());
}

if (styleKey === 'American') {
  section.insertAdjacentHTML('afterbegin', getAmericanDiagramSVG());
}
    });

    // SHOP COLLECTION LINKS
    if (shopLinks) {
      shopLinks.innerHTML = '';
      const seen = {};

      fits.forEach(r => {
        if (seen[r.size]) return;
        seen[r.size] = true;

        const link = SIZE_COLLECTIONS[r.size];
        if (!link) return;

        const a = document.createElement('a');
        a.className = 'prc-shop-link';
        a.href = link;
        a.innerHTML =
          '<span>All ' + r.size + ' tables</span><span>→</span>';

        shopLinks.appendChild(a);
      });
    }
  }

  // --------------------------
  // MAIN SUBMIT HANDLER
  // --------------------------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearResults();

    const unit = unitInput.value || 'ft';
    const rawLength = (lengthInput.value || '').replace(',', '.');
    const rawWidth = (widthInput.value || '').replace(',', '.');

    const lengthVal = parseFloat(rawLength);
    const widthVal = parseFloat(rawWidth);
    const cue = getSelectedCue();

    if (!lengthVal || !widthVal || lengthVal <= 0 || widthVal <= 0) {
      errorEl.textContent = 'Please enter a valid room length and width.';
      return;
    }

    const lengthM = unit === 'ft' ? lengthVal * M_PER_FT : lengthVal;
    const widthM = unit === 'ft' ? widthVal * M_PER_FT : widthVal;

    if (lengthM < 2 || widthM < 2) {
      errorEl.textContent =
        'That room seems very small for a pool table. Please double-check your measurements.';
    }

    const fits = [];

    TABLE_DATA.forEach(row => {
      if (row.cue !== cue) return;

      const fitsLength = lengthM >= row.roomLengthM;
      const fitsWidth = widthM >= row.roomWidthM;

      if (fitsLength && fitsWidth) {
        const diffL = lengthM - row.roomLengthM;
        const diffW = widthM - row.roomWidthM;
        const minDiff = Math.min(diffL, diffW);

        const comfort = minDiff >= 0.3 ? 'comfortable' : 'tight';

        fits.push({
          ...row,
          comfort: comfort,
          extraClearanceM: minDiff
        });
      }
    });

    const room = {
      length: lengthVal,
      width: widthVal,
      unit: unit
    };

    renderResults(fits, room, cue);
  });

})();
